var moment = require('moment');
var _ = require('lodash');

export const initialState = {
    year : moment.utc().year(),
    firstMonth: 6,
    inEdit: false,
    ranges: { availability: [], pricing: []},
    firstPeriodStart: null,
    firstPeriodEnd: null,
    errorMessage: null,
    firstPeriodPrice: 0,
    firstPeriodPriceBeforeDiscount: 0,
    numPeople: 1,
    vertical: false,
    editComplete: true,
    type: 'desktop',
    lengthOfStay: 7,
    extrasIncludedPrice: 0,
    bookingType: 'booking',
};

export const overlapsWith = (start1, end1, start2, end2) => {
    return (start1.isSameOrBefore(end2) && end1.isSameOrAfter(start2));
}

export const applyAsWindow = (start, end, ranges) => {
    var affected = _.filter(ranges, (range) => {
        return (overlapsWith(start, end, range.start, range.end));
    });
    return _.map(affected, (range) => {
        var newStart = moment.max(range.start, start);
        var newEnd = moment.min(range.end, end);
        var discountEndsAt = (range.discountEndsAt !== null) ? range.discountEndsAt : null;
        return {start: newStart, end: newEnd, price: range.price, priceWithDiscount: (discountEndsAt !== null) ? range.priceWithDiscount : range.price, minimalStay: range.minimalStay, discountEndsAt: discountEndsAt};
    });
}

export const isRangeAvailable = (start, end, ranges) => {
    const daysAvailable = _.reduce(applyAsWindow(start, end, ranges), (acc, range) => {
        return acc + range.end.diff(range.start, 'days') + 1;
    },0);
    return daysAvailable == end.diff(start, 'days') + 1;
}

export const isDayAvailable = (day, ranges) => {
    var av = _.some(ranges, (range) => {
        return overlapsWith(day, day, range.start, range.end)
    });
    return av;
}

export const priceInRange = (start, end, ranges) => {
    return _.reduce(applyAsWindow(start, end, ranges), (acc, range) => {
        var price = range.priceWithDiscount || range.price;
        return  acc + price * (range.end.diff(range.start, 'days') + 1);

    }, 0);
}

export const priceBeforeDiscountInRange = (start, end, ranges) => {
    return _.reduce(applyAsWindow(start, end, ranges), (acc, range) => {
        return acc + range.price * (range.end.diff(range.start, 'days') + 1);
    }, 0);
}
export const discountEndsInRange = (start, end, ranges) => {
    var range = applyAsWindow(start, end, ranges);
    if (range) {
        return range[0].discountEndsAt;
    }
    return null;
}

export const calculateMinimalStay = (start, end, ranges) => {
    return _.maxBy(applyAsWindow(start, end, ranges), (range) => {return range.minimalStay}).minimalStay;
}

export const maxDayAvailableinRange = (start, end, availability) => {
    var ref = start.clone();
    while (ref.isSameOrBefore(end)) {
        ref.add(1, 'days');
        if (!isDayAvailable(ref, availability)) {
            ref.subtract(1, 'days');
            return ref;
        }
    }
    return end;
}

export const findNextDepartureDate = (startDay, pricing, availability) => {
    var ended = false;
    var currentDay = startDay.clone();
    var range;

    while (!ended) {
        if (!isDayAvailable(currentDay, availability)) {
            ended = true;
            continue;
        }
        // Find current princing range
        range = _.find(pricing, (range) => {
            return currentDay.isSameOrAfter(range.start) && currentDay.isSameOrBefore(range.end);
        });
        if (range) {
            var nextDay = currentDay.clone();
            nextDay.add(1, 'days');
            if (!isDayAvailable(nextDay, availability)) {
                return currentDay;
            }
            if (range.arrivalDays.indexOf(nextDay.day()) != -1) {
                return currentDay;
            }
            currentDay.add(1, 'days');
        } else {
            ended = true;
        }
    }
    return null;
}

export const findPrevDepartureDate = (startDay, pricing, availability) => {
    var ended = false;
    var currentDay = startDay.clone();
    var range;

    while (!ended) {
        if (!isDayAvailable(currentDay, availability)) {
            ended = true;
        }
        // Find current princing range
        range = _.find(pricing, (range) => {
            return currentDay.isSameOrAfter(range.start) && currentDay.isSameOrBefore(range.end);
        });
        if (range) {
            var nextDay = currentDay.clone();
            nextDay.add(1, 'days');
            if (range.arrivalDays.indexOf(nextDay.day()) != -1) {
                return currentDay;
            }
            currentDay.subtract(1, 'days');
        } else {
            ended = true;
        }
    }
    return null;
}

export const calculateEndDay = (firstDay, endDayIntended, pricing, availability) => {
    var minimalStay = calculateMinimalStay(firstDay, endDayIntended, pricing);
    var endDayAvailable = maxDayAvailableinRange(firstDay, endDayIntended, availability);
    var stayLength = endDayAvailable.diff(firstDay, 'days') + 1;

    var departureWithMinimalStay = stayLength >= minimalStay ? endDayAvailable : firstDay.clone().add(minimalStay - 1 , 'days');

    var day = findNextDepartureDate(departureWithMinimalStay.clone(), pricing, availability);
    if (!day) {
        return findPrevDepartureDate(departureWithMinimalStay.clone(), pricing, availability);
    } else {
        return day;
    }
}

export const canStartOn = (firstDay, pricing, availability) => {
    var minimalStay = calculateMinimalStay(firstDay, firstDay, pricing);

    // We first possible departure day that fullfills all the rules
    var minimalStayDate = firstDay.clone().add(minimalStay - 1 , 'days')
    var minimalDepartureDate = findNextDepartureDate(firstDay.clone(), pricing, availability);
    if (!minimalDepartureDate) {
        return false;
    }

    var shouldStayUntil = moment.max(minimalStayDate, minimalDepartureDate);

    var endDayAvailable = maxDayAvailableinRange(firstDay, shouldStayUntil, availability);
    return endDayAvailable.isSame(shouldStayUntil);
}

export const firstAvailablePeriod  = ( state ) => {
    const {firstPeriodStart, firstPeriodEnd, ranges} = state;
    if (firstPeriodStart) {
        return firstPeriodStart;
    }

    return moment('2025-07-01');
    var ended = false;
    var startDay;
    var possibleDay;
    var rangeDays = [];

    // get all possible days to check
    _.each(ranges.availability, (range) => {
        var startDay=range.start.clone();
        rangeDays.push(startDay.clone());
        while(startDay.add(1, 'days').isBefore(range.end)) {
            rangeDays.push(startDay.clone());
        }
    });

    rangeDays = _.sortBy(rangeDays, function(value) {return new moment(value);});

    while(!ended && rangeDays.length > 0) {
        startDay = rangeDays.shift().clone();

        // see if we can find a startday after today
        possibleDay = findStartDay(startDay, ranges.pricing);

        if (possibleDay !== null) {
            // check if the found day is an allowed arrival day
            if (canStartOn(possibleDay,ranges.pricing, ranges.availability) && findNextDepartureDate(possibleDay,ranges.pricing, ranges.availability)) {
                ended = true;
                // we give back month so calender focuses on month with first available arrival
                return possibleDay;
            } else {
                // make sure we check after the already found possible day
                if ( startDay.isSame(possibleDay) ) {
                    startDay.add(1,'days');
                } else {
                    startDay = possibleDay.clone().add(1, 'days');
                }
            }
        } else {
            // apparently no possible day found so we need to end and return with current month ( or maybe some preset default )
           ended = true;
        }

    }
}

export const findStartDay = (startDay, pricing) => {
    var currentDay = startDay;

    // Find start date in current pricing range
    var rangePricing = _.find(pricing, (rangePricing) => {
        return currentDay.isSameOrAfter(rangePricing.start) && currentDay.isSameOrBefore(rangePricing.end);
    });

    if (rangePricing) {
        return currentDay;
    }

    return null;
}

export default (state = initialState, action) => { 
    switch (action.type) {
        case 'UPDATE_LENGTHOFSTAY': {
            const {firstPeriodStart, firstPeriodEnd} = state;
            let newLOS = firstPeriodEnd.diff(firstPeriodStart, 'day') + 1 ;
            if (newLOS > 7) newLOS = 7;
            return Object.assign({}, state, {
                lengthOfStay: newLOS
            });
        }
        case 'FIRST_AVAILABLE_PERIOD':
            return Object.assign({}, state, {
                year: firstAvailablePeriod( state).year(),
                firstMonth: firstAvailablePeriod( state ).month()
            })

        case 'PREVIOUS_MONTH':
            return Object.assign({}, state, {
                firstMonth: state.firstMonth -1
            })
        case 'NEXT_MONTH':
            return Object.assign({}, state, {
                firstMonth: state.firstMonth +1
            })

        case 'RANGES_CHANGED': {
            const {firstPeriodStart, firstPeriodEnd, ranges, extrasIncludedPrice} = state;
            if (!firstPeriodStart || !firstPeriodEnd) {
                return state;
            }
            var currentStart = firstPeriodStart.clone();
            var currentEnd = firstPeriodEnd.clone().add(1,'day');
            var dateHolder = document.getElementById('date-holder');
            if(dateHolder) {
                dateHolder.getElementsByClassName('start-date')[0].querySelector('div').innerHTML = currentStart.format('DD-MM-YYYY');
                dateHolder.getElementsByClassName('end-date')[0].querySelector('div').innerHTML = currentEnd.format('DD-MM-YYYY');
            }
            document.dispatchEvent(new CustomEvent("Calendar_RANGES_CHANGED", {
                detail: {
                    dates: {
                        start: currentStart,
                        end:  firstPeriodEnd
                    },
                }
            }));
            document.getElementsByClassName("price-holder startingprice").innerHTML = '';
            var price = (priceInRange(firstPeriodStart, firstPeriodEnd, ranges.pricing[state.lengthOfStay])) + extrasIncludedPrice  ;
            var priceBeforeDiscount = (priceBeforeDiscountInRange(firstPeriodStart, firstPeriodEnd, ranges.pricing[state.lengthOfStay])) + extrasIncludedPrice ;

            var discountEndsAt = null;
            if (priceBeforeDiscount > price) {
                discountEndsAt = discountEndsInRange(firstPeriodStart, firstPeriodEnd, ranges.pricing[state.lengthOfStay]);
            }
            // GA event price setting
            var calculatorHolder = document.getElementById('calculator-holder');
            if (calculatorHolder) {
                calculatorHolder.dataset.gaEventPrice = price;
            }
            var calendarBooking = document.getElementById('calendar-booking');
            if (calendarBooking) {
                calendarBooking.dataset.gaEventPrice = price;
            }

            var formatter = new Intl.NumberFormat(window.CvrmLocale, {style: 'currency', currency: state.currency ? state.currency : 'EUR', minimumFractionDigits: 2});
            if (state.currency !== 'EUR') {
              price = price * state.currencyRate;
              priceBeforeDiscount = priceBeforeDiscount * state.currencyRate;
            }
            document.dispatchEvent(new CustomEvent("Calendar_UPDATE_PRICES", {   
                detail: {
                    priceBeforeDiscount: formatter.format(priceBeforeDiscount),
                    price: formatter.format(price),
                    discount: formatter.format(priceBeforeDiscount - price),
                    currency: state.currency,
                    active: (discountEndsAt === null  || price >= priceBeforeDiscount  ) ? false : true,
                    discountEndsAt: discountEndsAt,
                    start:  currentStart.format('DD-MM-YYYY'),
                    end: currentEnd.format('DD-MM-YYYY')
                }
            }));
            //let newPrice = (priceBeforeDiscount !== price) ? '<span class="slashthrough">' + formatter.format(priceBeforeDiscount) + '</span>&nbsp;' + formatter.format(price) : formatter.format(price);
            let priceContainer = document.getElementById('price-container');

            if (priceContainer) {
                if ( price > 0 ) {
                    priceContainer.innerHTML = formatter.format(price);
                    var pricingSlashThrough = document.getElementById('pricing-slashthrough');
                    if (discountEndsAt && priceBeforeDiscount > price) {
                        if (pricingSlashThrough) {
                            pricingSlashThrough.innerHTML = formatter.format(priceBeforeDiscount);
                            pricingSlashThrough.classList.remove('hide');
                        }
                    } else {
                        if (pricingSlashThrough) {
                            pricingSlashThrough.innerHTML = formatter.format(priceBeforeDiscount);
                            pricingSlashThrough.classList.add('hide');
                        }
                    }
                }
            }
            let fromPerDay = document.getElementById('from-perday');
            if (fromPerDay || price == 0) {
                fromPerDay.classList.add('d-none');
            }
            document.getElementsByClassName("results-block-discount discount-amount").innerHTML = formatter.format(price - priceBeforeDiscount);
            //$('.results-block-discount .discount-amount').html(formatter.format(price - priceBeforeDiscount));

            var buttonsToUpdate = [];
            buttonsToUpdate.push(document.getElementById('booking-holder-button'));
            buttonsToUpdate.push(document.getElementById('booking-option-holder-button'));
            buttonsToUpdate.push(document.getElementById('booking-holder-button-bottom'));
            buttonsToUpdate.push(document.getElementById('booking-holder-button-1'));
            buttonsToUpdate.push(document.getElementById('booking-option-holder-button-1'));
            buttonsToUpdate.push(document.getElementById('booking-option-holder-button-2'));
            buttonsToUpdate.push(document.getElementById('booking-holder-button-2'));
            buttonsToUpdate.push(document.getElementById('booking-holder-button-3'));

            if (buttonsToUpdate.length > 0 ) {
                _.each(buttonsToUpdate, function (el) {
                    if (el) {
                        el.dispatchEvent(new CustomEvent("updateButton", {
                                "detail": {
                                    "start":  currentStart.format('DD-MM-YYYY'),
                                    "end": currentEnd.format('DD-MM-YYYY')
                                }
                            }
                        ));
                    }
                });
            }

            return Object.assign({}, state, {
                firstPeriodPrice: (priceInRange(firstPeriodStart, firstPeriodEnd, ranges.pricing[state.lengthOfStay]) + extrasIncludedPrice),
                firstPeriodPriceBeforeDiscount: (priceBeforeDiscountInRange(firstPeriodStart, firstPeriodEnd, ranges.pricing[state.lengthOfStay]) + extrasIncludedPrice)
            })}

        case 'DAY_CLICK': {
            const {firstPeriodStart, inEdit, ranges, lengthOfStay} = state;

            if (inEdit) {
                var dayMouseClickEnd = action.day.clone();
                if (!firstPeriodStart.isSame(dayMouseClickEnd)) {
                    dayMouseClickEnd.subtract(1, 'day');
                }
                
                if (firstPeriodStart.isAfter(dayMouseClickEnd)) {
                    // Check if it is a possible arrival day
                    var range = _.find(ranges.pricing[lengthOfStay], (range) => {
                        return action.day.isSameOrAfter(range.start) && action.day.isSameOrBefore(range.end);
                    });

                    if (range && range.arrivalDays.indexOf(action.day.day()) != -1 && isDayAvailable(action.day, ranges.availability)) {
                        if (canStartOn(action.day, ranges.pricing[lengthOfStay], ranges.availability)) {
                            return Object.assign({}, state, {
                                inEdit: true,
                                firstPeriodStart : action.day.clone(),
                                firstPeriodEnd: calculateEndDay(action.day, action.day, ranges.pricing[lengthOfStay], ranges.availability),
                                errorMessage: null,
                            })
                        } else {
                            return Object.assign({}, state, {
                                errorMessage: 'Cannot arrive on selected day, because there is a minimum booking period',
                            })
                        }

                        return Object.assign({}, state, {
                            inEdit: true,
                            firstPeriodStart : action.day.clone(),
                            firstPeriodEnd: calculateEndDay(action.day, action.day, ranges.pricing[lengthOfStay], ranges.availability),
                            errorMessage: null,
                        })
                    } else { 
                        return state;
                    }
                } else {
                    return Object.assign({}, state, {
                        inEdit: false,
                        firstPeriodEnd: calculateEndDay(firstPeriodStart, dayMouseClickEnd, ranges.pricing[lengthOfStay], ranges.availability),
                        errorMessage: null,
                    })
                }
            } else {
                // Check if it is a possible arrival day
                var range = _.find(ranges.pricing[state.lengthOfStay], (range) => {
                    return action.day.isSameOrAfter(range.start) && action.day.isSameOrBefore(range.end);
                });
                if (range && range.arrivalDays.indexOf(action.day.day()) != -1 && isDayAvailable(action.day, ranges.availability)) {
                    // If it is no evident why it is impossible to start this day,
                    // show error
                    if (canStartOn(action.day, ranges.pricing[state.lengthOfStay], ranges.availability)) {
                        return Object.assign({}, state, {
                            inEdit: true,
                            firstPeriodStart: action.day,
                            firstPeriodEnd: calculateEndDay(action.day, action.day, ranges.pricing[state.lengthOfStay], ranges.availability),
                            errorMessage: null,
                        })
                    } else {
                        return Object.assign({}, state, {
                            errorMessage: 'Cannot arrive on selected day, because there is a mininum booking period',
                        })
                    }
                }
                return state;
            }
           }

        case 'EDIT_COMPLETE': {
            return Object.assign({}, state, {
                editComplete: true,
            })
        }

        case 'EDIT_INCOMPLETE': {
            return Object.assign({}, state, {
                editComplete: false,
            })
        }

        case 'DAY_MOUSE_OVER': {
            const {firstPeriodStart, firstPeriodEnd, inEdit, ranges} = state;
            if (!inEdit || action.day.isBefore(firstPeriodStart)) {
                return state;
            } else {
                var dayMouseOverEnd = action.day.clone();
                if (!firstPeriodStart.isSame(dayMouseOverEnd)) {
                    dayMouseOverEnd.subtract(1, 'day');
                }
                return Object.assign({}, state, {
                    inEdit: true,
                    firstPeriodEnd: calculateEndDay(firstPeriodStart, dayMouseOverEnd, ranges.pricing[state.lengthOfStay], ranges.availability),
                    errorMessage: null,
                })
            }}
        default:
            return state
    }
}
